export const initializeGA = () => {
    if (window.gtag) {
        let data = {
            "icei_user_account": localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).account : null,
            "icei_topuser_account": localStorage.getItem("topUser") ? JSON.parse(localStorage.getItem("topUser")).account : null
        }
        // console.log({ data })
        window.gtag('config', 'G-4Q1SVGP27Q', data);
    }
};